import Manager from "./main/manager";
import Main from "./main/index";

export const baseUrl = 'https://usaedu.griffinintl.net/admin/'

export const managerApi = new Manager(baseUrl);
export const mainApi = new Main(baseUrl);

const Api = {
	managerApi,
	mainApi
}
export default Api